const CompanyTypeEnum = {
  TRADER: "TRADER",
  TRANSPORT: "TRANSPORT",
  ADMIN: "ADMIN",
  DEPARTMENT: "DEPARTMENT",
} as const;

export default CompanyTypeEnum;
export type CompanyType = "TRADER" | "TRANSPORT" | "ADMIN" | "DEPARTMENT";
